import React from 'react';
import Api from '../../../services/Api';
import INFTCollection from '../models/INFTCollection';
import uniqBy from 'lodash/uniqBy';


export const defaultCollection = {
    id: 'yetiswapCollection',
    tokenAddress: '0xc01b3e9678c73A96BA51d040ce435d1c28fd1E1d',
    name: 'YetiSwap Collection',
    category: 0,
    creatorAddress: '',
    cardFormat: "DefaultCard",
    detailFormat: "DefaultDetail",
    activityFormat: "ActivityDetail"
}

const useNFTCollectionList = () => {
    const [collectionList, setCollectionList] = React.useState<INFTCollection[]>([]);

    React.useEffect(() => {
        let isCancelled = false;
        //look to cache for nft collection
        const cachedcollectionList = sessionStorage.getItem(`nftCollectionList`);
        if (cachedcollectionList) {
            setCollectionList(JSON.parse(cachedcollectionList));
        } else {
            Api.get('https://api.yetiswap.app/collection/getVerifiedAll').then((res: INFTCollection[]) => {
                if (!isCancelled) {
                    if (res.length > 0) {
                        let data = uniqBy(res, 'id').concat(defaultCollection);
                        setCollectionList(data)
                        sessionStorage.setItem("nftCollectionList", JSON.stringify(data));
                    }
                }
            });
        }
        return () => {
            isCancelled = true;
        }
    }, []);

    return collectionList;
}

export default useNFTCollectionList;

